<template>
    <div>
        <card-header title='New Certification' icon="fa-plus"/>

        <card-body>
            <certification-form :certification="certification"/>
        </card-body>

        <card-footer class="pt-3 pb-3">
            <div class="columns">
                <div class="column has-text-right">
                    <b-button
                        type="is-primary"
                        size="is-small"
                        @click="submit"
                        :disabled="!certification.title"
                    ><i class="fas fa-plus mr-2"></i>New Certification</b-button>
                </div>
            </div>
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardBody from "@/TIER/components/CardBody";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardFooter from "@/TIER/components/CardFooter";

    import CourseForm from "@/cards/courses/CourseForm";

    import {client as http} from '../../http_client';
    import CertificationForm from "@/cards/certifications/CertificationForm";

    export default {
        components: {CertificationForm, CardHeader, CardToolbar, CardBody, CardFooter, CourseForm},
        props: ['card'],
        data() {
            return {
                certification: {}
            }
        },
        methods: {
            submit: function() {
                this.$emit('loading', true);
                http.post('certs/', this.certification, {force: true}).then(response => {
                    this.$reloadCard('certifications');
                    this.$closeCard(this.card);
                }).catch(err => {

                });
            }
        }
    }
</script>
